<template>
  <div class="promotion-netflix" :class="{'en-style': language === 'en'}"> 
      <div class="container-top">
        <plex-header class="" style="width:100%"></plex-header>
        <div class="banner-wrap container">
          <h3 class="title">{{$t('banner_title')}}</h3>
          <div class="content">
            <div class="left-wrap">
              <p class="des">
                {{$t('banner_des')}}
              </p> 
              <router-link to="/">{{$t('banner_btn')}}</router-link>
            </div>
            <div class="right-wrap">
              <img  class="" src="../../../../static/img/promotion/bbc-right.png" alt="">
            </div>
          </div>
        </div>
        <img  class="right-img" src="../../../../static/img/promotion/bbc-right.png" alt="">
      </div>
      
    <div class="container">
      
      <div class="bbcInfo-wrap">
        <h3 class="title">{{$t('bbcInfo_title')}}</h3> 
        <div class="content">
          <div class="left">
            <img src="../../../../static/img/promotion/bbc-img.png" alt="">
          </div>
          <div class="right">
            <div>
              <p>{{$t('bbcInfo_des')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="benefit-wrap">
          <h3 class="title">{{$t('benefit_title')}}</h3> 
          <div class="benefit">
            <div class="content">
              <div class="box ">
                <div class="item">
                  <img src="../../../../static/img/promotion/bbc-benefit1.png" alt="">
                  <div class="des">
                    {{$t('benefit_item1')}}
                  </div>
                </div>
                <div class="item">
                  <img src="../../../../static/img/promotion/bbc-benefit2.png" alt="">
                  <div class="des">
                    {{$t('benefit_item2')}}
                  </div>
                </div>
                <div class="item">
                  <img src="../../../../static/img/promotion/bbc-benefit3.png" alt="">
                  <div class="des">
                    {{$t('benefit_item3')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <router-link to="/download" class="down-btn">{{$t('downloadPlex')}}</router-link>
      </div> 
      <div class="simple-steps pc-show">
        <h4>{{$t('steps_title')}}</h4>
        <div class="steps-item">
          <div class="item">
            <img class="step-icon" src="../../../../static/img/promotion/step-icon1.png" alt="">
            <img class="step-img" src="../../../../static/img/promotion/netflix-step1.png" alt="">
            <div class="des">{{$t('steps_item1')}}</div>
          </div>
          <div class="item">
            <img class="step-icon" src="../../../../static/img/promotion/step-icon2.png" alt="">
            <img class="step-img" src="../../../../static/img/promotion/netflix-step2.png" alt="">
            <div class="des">{{$t('steps_item2')}}</div>
          </div>
          <div class="item">
            <img class="step-icon" src="../../../../static/img/promotion/step-icon3.png" alt="">
            <img class="step-img" src="../../../../static/img/promotion/netflix-step3.png" alt="">
            <div class="des">{{$t('steps_item3')}}</div>
          </div>
        </div>
        <router-link to="/download" class="down-btn">{{$t('downloadPlex')}}</router-link>
      </div>
      <div class="simple-steps phone-show">
        <h4>{{$t('steps_title')}}</h4>
        <div class="steps">
          <div class="steps-text">
            <img class="step-img" src="../../../../static/img/promotion/netflix-step1.png" alt=""> <span>{{$t('steps_item1')}}</span>
          </div>
          <div class="steps-text">
            <img class="step-img" src="../../../../static/img/promotion/netflix-step2.png" alt=""> <span>{{$t('steps_item2')}}</span>
          </div>
          <div class="steps-text">
            <img class="step-img" src="../../../../static/img/promotion/netflix-step3.png" alt=""> <span>{{$t('steps_item3')}}</span>
          </div>
        </div>
        <router-link to="/download" class="down-btn">{{$t('getPlex')}}</router-link>
      </div>

      <div class="reviews">
        <h4>{{$t('review_title')}}</h4>
        <div class="carousel">
          <review-text></review-text>
        </div>
      </div>

      <div class="features">
        <h4>{{$t('feature_title')}}</h4>
        <div class="ftu-text1">
          <div>
            <span>{{$t('features_title1')}}</span>
            <span class="small">{{$t('features_con1')}}</span>
          </div>
          <div>
            <span>{{$t('features_title2')}}</span>
            <span class="small">{{$t('features_con2')}}</span>
          </div>
          <div>
            <span>{{$t('features_title3')}}</span>
            <span class="small">{{$t('features_con3')}}</span>
          </div>
        </div>
        <div class="ftu-text2">
          <div>
            <span>{{$t('features_title4')}}</span>
            <span class="small">{{$t('features_con4')}}</span>
          </div>
          <div>
            <span>{{$t('features_title5')}}</span>
            <span class="small">{{$t('features_con5')}}</span>
          </div>
          <div>
            <span>{{$t('features_title6')}}</span>
            <span class="small">{{$t('features_con6')}}</span>
          </div>
        </div>
        <router-link to="/download" class="down-btn">{{$t('getPlex')}}</router-link>
      </div>
      
      <div class="faqs">
        <h4>{{$t('faqs_title')}}</h4>
        <div>
          <span>{{$t('faqs_title1')}}</span>
          <span class="small">{{$t('faqs_con1')}}</span>
          <div class="attach-box">
            <div class="attach1">
              {{$t('faqs_des1')}}
            </div>
            <div class="attach2">
              <img src="../../../../static/img/promotion/bbc-faq-error.png" alt="">
              <p>
                {{$t('faqs_des2')}}
              </p>
            </div>
          </div>
        </div>
        <div>
          <span>{{$t('faqs_title2')}}</span>
          <span class="small">{{$t('faqs_con2')}}</span>
        </div>
        <div>
          <span>{{$t('faqs_title3')}}</span>
          <span class="small">{{$t('faqs_con3')}}</span>
        </div>
        <div>
          <span>{{$t('faqs_title4')}}</span>
          <span class="small">{{$t('faqs_con4')}}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <img class="footer-icon" v-if="language === 'zh'" src="../../../../static/img/promotion/netflix-footer-icon.png" alt="">
      <img class="footer-icon" v-if="language === 'en'" src="../../../../static/img/promotion/netflix-footer-icon-en.png" alt="">
      <p>{{$t('footer_con1')}}</p>
      <div class="star-wrap">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
      </div>
      <router-link to="/download" class="down-btn">{{$t('downloadPlex')}}</router-link>
    </div>
</div>
</template>

<script>
import locales from './lang'
import PlexHeader from '../../../components/plexHeader/mainHeader/Index.vue'
import ReviewText from './ReviewText.vue'
import cookie from '../../../lib/cookie'

export default {
  name: 'promotion-bbc',
  components: {PlexHeader, ReviewText},
  locales,
  created: function () {
    this.$store.commit('isSpecialHeader', true)
    cookie.setCookie('promotion_source', 'promotion-bbc', 30)
  },
  destroyed() {
    this.$store.commit('isSpecialHeader', false)
  },
  computed: {
    language() {
      return this.$store.state.currentLang
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/common.scss";
.promotion-netflix {
  font-family: MicrosoftYaHei;
  position: relative;
  .main-header-pc {
    z-index: 999 !important;
  }
  .container-top {
    position: relative;
    width: 100%;
    background-image: url(../../../../static/img/promotion/netflix-banner.png);
    background-repeat: no-repeat;
    position: relative;
    background-size: 100% 100%;
    .title {
      font-size: 62px;
      color: #fff;
      margin: 95px 0 160px;
      padding-left: 10%;
      padding-right: 40%;
    }
    .banner-wrap {
      max-width: 1680px;
      position: relative;
      z-index: 2;
      .content {
        display: flex;
        > div {
          width: 50%;
        }
        .left-wrap {
          padding-bottom: 115px;
          padding-left: 10%;
          .des {
            font-size: 24px;
            color: #fff;
            line-height: 62px;
          }
          a {
            display: block;
            max-width: 445px;
            height: 90px;
            color: #9761fd;
            background-color: #fff;
            font-size: 24px;
            line-height: 90px;
            text-align: center;
            margin-top: 55px;
          }
        }
        .right-wrap {
          position: relative;
          img {
            display: none;
          }
        }
      }
    }
    .right-img {
      right: 5%;
      bottom: 0;
      max-width: 770px;
      position: absolute;
      z-index: 1;
    }
    @media screen and (max-width: 1600px) {
      .right-img {
        right: 5%;
        bottom: 0;
        max-width: 700px;
        position: absolute;
        z-index: 1;
      }
    }
    @media screen and (max-width: 1440px) {
      .title {
        margin: 55px 0px;
        padding-left: 5%;
        font-size: 34px;
        line-height: 40px;
      }
      .banner-wrap {
        .content {
          flex-wrap: wrap;
          .left-wrap {
            width: 60%;
            padding: 0 5% 40px;
            .des {
              font-size: 20px;
              line-height: 40px;
            }
            a {
              margin-top: 30px;
            }
          }
          .right-wrap {
            width: 40%;
            text-align: center;
            img {
              max-width: 100%;
            }
          }
        }
      }
      .right-img {
        width: 400px;
      }
    }
    @media screen and (max-width: 1000px) {
      .title {
        margin: 25px 0px 0;
        padding: 0 8% 30px;
        font-size: 34px;
        line-height: 40px;
      }
      .banner-wrap {
        .content {
          flex-direction: column;
          .left-wrap {
            width: 100%;
            padding: 0 8% 50px;
            .des {
              font-size: 16px;
              line-height: 34px;
            }
            a {
              height: 66px;
              line-height: 66px;
            }
          }
          .right-wrap {
            width: 100%;
            text-align: center;
            img {
              display: inline;
              max-width: 80%;
            }
          }
        }
      }
      .right-img {
        display: none;
      }
    }
  }

  .down-btn {
    display: inline-block;
    height: 66px;
    width: 350px;
    margin: 40px 0 80px;
    font-size: 24px;
    letter-spacing: 1.4px;
    line-height: 66px;
    color: #ffffff;
    text-align: center;
    background: linear-gradient(125.23deg, #416cf8 0%, #ec55ff 100%);
  }
  @media screen and (max-width: 768px) {
    .down-btn {
      margin: 20px 0 20px;
      width: 300px;
    }
  }
  .container {
    z-index: 11;
    max-width: 1200px;
    padding: 0;
    margin: 0 auto;
    background: transparent;
    
  .bbcInfo-wrap{
    padding: 80px 0 0;
    .title {
      font-size: 36px;
      color: #333;
      font-weight: 600;
      margin: 0 0 40px;
      text-align: center;
    }
    .content{
      display: flex;
      .right{
        margin-top: 15px;
        background-color: #f5f5f5;
        align-items: center;
        height: 257px;
        padding: 30px 20px 0;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        line-height: 32px;
      }
    }
  }
  @media screen and (max-width: 1100px) {
    .bbcInfo-wrap{
      padding: 30px 0 0;
      .content{
        flex-wrap: wrap;
        padding: 0 8% 20px;
        .right{
          height: auto;
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .bbcInfo-wrap{
      padding: 30px 0 0;
      .title {
        font-size: 36px;
        color: #333;
        font-weight: 600;
        margin: 0 0 40px;
        text-align: center;
      }
      .content{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 8% 20px;
        .left{
          text-align: center;
          img{
            max-width: 90%;
            margin: 0 auto;
          }
        }
        .right{
          padding: 15px 20px 0;
          height: auto;
          width: 100%;
        }
      }
    }
  }
  .benefit-wrap {
    text-align: center;
    padding: 80px 0 0;
    .title {
      font-size: 36px;
      color: #333;
      font-weight: 600;
      margin: 0 0 40px;
      text-align: center;
    }
      .benefit{
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        .content{
          max-width: 1200px;
          overflow: hidden;
          .box{
            padding: 1px;
            display: flex;
            transition: all 0.5s;
            left: 0;
            position: relative;
            .item{
              width: 360px;
              background-color: #fff;
              box-shadow: 0 0 5px 1px #e3e3e3;
              margin-left: 20px;
              img{
                width: 100%;
              }
              .des{
                font-size: 24px;
                text-align: center;
                height: 88px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: left;
                padding: 0 20px;
              }
            }
            .item:first-child{
              margin-left: 0px;
            }
          }
        }
      }
    }
    @media screen and (max-width: 768px) {
      .benefit-wrap {
        text-align: center;
        padding: 30px 0 0;
        .title {
          padding: 0 20px;
          font-size: 24px;
          color: #333;
          font-weight: 600;
          margin: 0 0 40px;
          text-align: center;
        }
        .benefit{
          position: relative;
          .content{
            .box{
              width: 100% !important;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .item{
                width: 300px;
                float: none;
                margin: 10px 0;
                .des{
                  font-size: 20px;
                }
              }
            }
          }
        }
      }
    }
    .simple-steps {
      text-align: center;
      h4 {
        font-size: 36px;
        color: #333;
        font-weight: 600;
        margin: 0 0 80px;
        text-align: center;
      }
      .steps-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0 0px;
        justify-content: space-between;
        .item {
          background-color: #fff;
          box-shadow: 0 0 10px 0 #e4e4e4;
          width: 375px;
          padding: 20px 0 0;
          position: relative;
          img.step-img {
            height: 282px;
          }
          img.step-icon {
            position: absolute;
            left: 10px;
            top: -50px;
          }
          .des {
            font-size: 18px;
            height: 66px;
            line-height: 66px;
            color: #333;
            box-shadow: 0 0 10px 0 #e4e4e4;
          }
        }
      }
      .steps-text {
        display: flex;
        justify-content: space-between;
        span {
          display: inline-block;
          width: 340px;
          font-size: 18px;
          font-weight: 900;
          letter-spacing: 1.05px;
          line-height: 34px;
          color: #666666;
          text-align: left;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .simple-steps {
        margin: 20px auto 0;
        > h4 {
          padding: 0 20px;
          font-size: 24px;
          color: #333;
          font-weight: 600;
          margin: 0 0 40px;
          text-align: center;
        }
        .steps {
          padding: 0 20px;
          .steps-text {
            max-width: 600px;
            margin: 0 auto 30px;
            img.step-img {
              width: auto;
              height: 140px;
              padding: 0px 10px;
            }
            img.step-icon {
              display: none;
            }
            span {
              font-size: 14px;
              line-height: 24px;
              padding: 0 20px;
            }
          }
        }
      }
    }
    .reviews {
      text-align: center;
      h4 {
        font-size: 36px;
        color: #333;
        font-weight: 600;
        margin: 0 0 40px;
        text-align: center;
      }
      .carousel {
        width: 100%;
        margin: 60px auto 0;
        position: relative;
        > div {
          overflow: hidden;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .reviews {
        padding: 20px 0;
        h4 {
          padding: 0 20px;
          font-size: 24px;
          color: #333;
          font-weight: 600;
          margin: 0 0 40px;
          text-align: center;
        }
      }
    }
    .features {
      margin-top: 80px;
      text-align: center;
      h4 {
        font-size: 36px;
        color: #333;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
      .ftu-text1,
      .ftu-text2 {
        display: flex;
        justify-content: space-between;
        text-align: left;
        div {
          width: 387px;
          height: 214px;
          padding: 30px 80px 0 20px;
          border: 1px solid #979797;
          background-repeat: no-repeat;
          background-position: 95% 90%;
          span {
            display: block;
            font-size: 18px;
            font-weight: 900;
            letter-spacing: 1.05px;
            line-height: 24px;
            color: #333;
          }
          span.small {
            margin-top: 20px;
            font-weight: 400;
            color: #333;
            font-size: 14px;
            line-height: 24px;
          }
        }
        div:nth-child(1) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon1.png);
        }
        div:nth-child(2) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon2.png);
        }
        div:nth-child(3) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon3.png);
        }
      }
      .ftu-text1 {
        margin-top: 40px;
      }
      .ftu-text2 {
        margin: 20px 0 0px;
        div:nth-child(1) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon4.png);
        }
        div:nth-child(2) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon5.png);
        }
        div:nth-child(3) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon6.png);
        }
      }
    }

    @media screen and (max-width: 768px) {
      .features {
        padding: 20px 0;
        margin-top: 0;
        h4 {
          padding: 0 20px;
          font-size: 24px;
          color: #333;
          font-weight: 600;
          margin: 0 0 40px;
          text-align: center;
        }
        .ftu-text1 {
          width: 90%;
          margin: 0 auto;
          justify-content: center;
          flex-wrap: wrap;
          div {
            margin-top: 0 !important;
            margin: 20px 0;
            padding: 18px 20px 0 20px;
            height: 190px;
          }
        }
        .ftu-text2 {
          width: 90%;
          margin: 0 auto;
          justify-content: center;
          flex-wrap: wrap;
          margin-bottom: 0 !important;
          div {
            margin-top: 0 !important;
            margin: 20px 0;
            padding: 18px 20px 0 20px;
            height: 180px;
          }
        }
      }
    }
    .faqs {
      text-align: center;
      h4 {
        font-size: 36px;
        color: #333;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
      div {
        margin-top: 30px;
      }
      span {
        display: block;
        font-size: 18px;
        font-weight: 900;
        letter-spacing: 1.05px;
        line-height: 22px;
        text-align: left;
        color: #333;
      }
      span.small {
        margin-top: 15px;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
      }
      .attach-box {
        text-align: left;
        margin-top: 15px;
        .attach1 {
          margin-top: 0px;
          background-color: #f2f2f2;
          display: inline-block;
          height: 48px;
          line-height: 48px;
          padding: 0 20px;
          font-size: 16px;
          position: relative;
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          &:before {
            content: "";
            display: block;
            width: 14px;
            height: 100%;
            left: 0;
            top: 0;
            position: absolute;
            border-radius: 14px;
            background-color: #c539fe;
          }
        }
        .attach2 {
          display: flex;
          margin-top: 15px;
          padding: 20px;
          background-color: #f2f2f2;
          p {
            margin-left: 10px;
            font-weight: 600;
            font-size: 14px;
            line-height: 28px;
          }
        }
      }
    }
    @media screen and (max-width: 768px) {
      .faqs {
        margin: 20px !important;
        h4 {
          padding: 0 20px;
          font-size: 24px;
          color: #333;
          font-weight: 600;
          margin: 0 0 40px;
          text-align: center;
        }
        .attach1 {
          height: auto !important;
        }
        .attach2 {
          flex-wrap: wrap;
          img {
            max-width: 100%;
          }
        }
      }
    }
  }

  .footer {
    position: relative;
    text-align: center;
    height: auto;
    margin: 80px auto 0;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    background-image: url(../../../../static/img/promotion/netflix-footer-bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    > img {
      max-width: 385px;
      top: -60px;
      position: relative;
    }
    p {
      font-size: 28px;
      color: #fff;
      font-weight: 600;
      margin: 0px 0 20px;
    }
    .down-btn {
      background: #fff;
      color: #a15ffe;
      margin-bottom: 100px;
    }
  }

  @media screen and (max-width: 768px) {
    .footer {
      > img {
        max-width: 80%;
        top: -60px;
        position: relative;
      }
      p {
        font-size: 22px;
        color: #fff;
        font-weight: 600;
        margin: 0px 0 20px;
      }
      .star-wrap {
        img {
          width: 30px;
        }
      }
    }
  }
  
  &.en-style{
    .container-top{
      .banner-wrap{
         .content{
          .left-wrap{
            .des {
              line-height: 36px;
            }
          } 
         } 
      }
    } 
    @media screen and (max-width: 768px) {
      .container-top{
        .banner-wrap{
          .content{
            .left-wrap{
              .des {
                line-height: 24px;
              }
            } 
          } 
        }
      } 
    }
    .container{
      .bbcInfo-wrap{
        .content{
          text-align: center;
          justify-content: center;
        }
      }
      .benefit{
        .content{
          .box{
            .item{
              .des{
                font-size: 18px;
              }
            }
          }
        }
      }
      .simple-steps{
         .steps-item{
          .item{
            .des{
              font-size: 16px;
              line-height: 33px;
            }
          }
         }
      }
      .features{
        .ftu-text1,.ftu-text2{
          div{
            padding: 20px 20px 0 20px;
            height: 260px;
            span{
              font-size: 16px;
              height: 48px;
            }
            span.small{
              line-height: 18px;
              height: auto;
            }
          }
        } 
      }
      .faqs{
        .attach-box{
          .attach1{
            height: auto;
          }
        }
      }
    }
  }
  .phone-show {
    display: none;
  }
  .pc-show {
    display: block;
  }
  @media screen and (max-width: 768px) {
    .phone-show {
      display: block;
    }
    .pc-show {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Bbc.vue?b309548e